module.exports = __webpack_public_path__ + "static/img/evocom.43cd9d63.png";